/*eslint-disable*/ export const messages = JSON.parse("{\"pill.aria.openFilter\":[\"Åbn filter\"],\"pill.aria.removeFilter\":[\"Fjern filter \",[\"label\"]]}");
//# sourceMappingURL=messages.mjs.map